module.exports = __webpack_public_path__ + "img/package-box.d293c808.svg";